import { useEffect } from 'react';
import { atomFamily, useRecoilCallback } from 'recoil';
import { Event } from 'services/api';

export const isStarredState = atomFamily({
  key: 'StarredEvents',
  default: false as boolean,
});

export const useSetStarredState = (events?: Event[] | Event): void => {
  const setStarredState = useRecoilCallback(({ set }) => (events: Event[]) =>
    events?.filter(Boolean).map(({ id, isStarred }) => {
      if (isStarred !== undefined) set(isStarredState(id), isStarred);
    }),
  );

  useEffect(() => {
    if (Array.isArray(events)) setStarredState(events);
    else if (events) setStarredState([events]);
  }, [events]);
};
